export const ActiveOnboardingIcons = () => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='24' height='24' rx='12' fill='#E5F3F7' />
            <circle cx='12' cy='12' r='4' fill='#0088B2' />
        </svg>
    );
};

export const InActiveOnboardingIcons = () => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clip-path='url(#clip0_11136_288)'>
                <rect width='24' height='24' rx='12' fill='#F9FAFB' />
                <circle cx='12' cy='12' r='4' fill='#EAECF0' />
            </g>
            <defs>
                <clipPath id='clip0_11136_288'>
                    <rect width='24' height='24' rx='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export const CompletedOnboardingIcons = () => {
    return (
        <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_11136_2545)'>
                <rect width='24' height='24' rx='12' fill='#E5F3F7' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M17.0965 7.38967L9.9365 14.2997L8.0365 12.2697C7.6865 11.9397 7.1365 11.9197 6.7365 12.1997C6.3465 12.4897 6.2365 12.9997 6.4765 13.4097L8.7265 17.0697C8.9465 17.4097 9.3265 17.6197 9.7565 17.6197C10.1665 17.6197 10.5565 17.4097 10.7765 17.0697C11.1365 16.5997 18.0065 8.40967 18.0065 8.40967C18.9065 7.48967 17.8165 6.67967 17.0965 7.37967V7.38967Z'
                    fill='#0088B2'
                />
            </g>
            <defs>
                <clipPath id='clip0_11136_2545'>
                    <rect width='24' height='24' rx='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};
